import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.bodyTemperatureSettingForm.loading;
export const selectErrorMessage = (state: RootState) =>
  state.bodyTemperatureSettingForm.error;
export const bodyTemperatureSettingFormResponse = (state: RootState) =>
  state.bodyTemperatureSettingForm.bodyTemperatureSettingFormResponse;
